import { useState, useLayoutEffect } from 'react';

// This variable is shared between different instances of this custom hook,
// but there is no problem with it because it holds the same scroll coordinates
// from window, which is unique.
let previousScrollCoordinates = { x: 0, y: 0 };

const getScrollCoordinates = () => {
  return {
    x: window.scrollX,
    y: window.scrollY
  };
};

export const useWindowScrollDirection = () => {
  const [scrollDirection, setScrollDirection] = useState({
    x: undefined,
    y: undefined
  });

  const handleEvent = () => {
    const scrollCoordinates = getScrollCoordinates();
    const newScrollDirection = { ...scrollDirection };
    if (previousScrollCoordinates.x > scrollCoordinates.x) {
      newScrollDirection.x = 'right';
    }
    if (previousScrollCoordinates.x < scrollCoordinates.x) {
      newScrollDirection.x = 'left';
    }
    if (previousScrollCoordinates.y > scrollCoordinates.y) {
      newScrollDirection.y = 'up';
    }
    if (previousScrollCoordinates.y < scrollCoordinates.y) {
      newScrollDirection.y = 'down';
    }
    previousScrollCoordinates = scrollCoordinates;
    if (
      newScrollDirection.x !== scrollDirection.x ||
      newScrollDirection.y !== scrollDirection.y
    ) {
      setScrollDirection(newScrollDirection);
    }
  };

  /* We use useLayoutEffect because:
  1) this hook's event (handleEvent), is not throttled, so it executes continuously, at high rate
  2) handleEvent sets state, which is an asynchronous operation
  Because of that, state is set twice, due to one event being executed
  before setScrollDirection has finished
  */
  useLayoutEffect(() => {
    window.addEventListener('scroll', handleEvent, {
      passive: true
    });
    window.addEventListener('resize', handleEvent, {
      passive: true
    });
    return () => {
      window.removeEventListener('scroll', handleEvent, {
        passive: true
      });
      window.removeEventListener('resize', handleEvent, {
        passive: true
      });
    };
  }, [scrollDirection]);

  return scrollDirection;
};
